import Header from "./Filter/Filter";
import useSize from "../../../../../Utils/useSize/useSize";
import toast from "react-hot-toast";
import { useCallback, useEffect, useRef, useState } from "react";
import Backend from "../../../../../Backend/Backend";
import Loading from "../../../../../Utils/Loading/Loading";
import NotFound from "../../../../../Utils/NotFound/NotFound";
import Menu from "./Menu/Menu";
import TransactionCard from "./TransactionCard/TransactionCard";

const backend = await new Backend().init();

export default function TransactionHistory() {
  const windowSize = useSize();
  const debounceTimeout = useRef(null);

  const [transactions, setTransactions] = useState([]);
  const [originalTransactions, setOriginalTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedFilter, setSelectedFilter] = useState("all"); // default: all
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    loadTransaction();
  }, []);

  const loadTransaction = useCallback(async () => {
    setLoading(true);
    try {
      const payload = {
        server: localStorage.getItem("server"),
        id: localStorage.getItem("id"),
        user_id: localStorage.getItem("id"),
        token: localStorage.getItem("token"),
        username: localStorage.getItem("username"),
      };

      const res = await backend.transaction(payload);

      if (res.error === "False") {
        setTransactions(res.transactions || []);
        setOriginalTransactions(res.transactions || []);
      } else {
        if (res.logout === 1) {
          window.LogOut();
        } else {
          toast.error(res.message);
        }
      }
    } catch (err) {
      console.error("Failed to load transactions:", err);
      toast.error("Network Error. Could not connect to the server. Please try again.");
    } finally {
      setLoading(false);
    }
  }, []);

  // 🔍 Handle search
  const handleSearch = (value) => {
    setSearchQuery(value);
    clearTimeout(debounceTimeout.current);
    debounceTimeout.current = setTimeout(() => {
      applyFilters(value, selectedFilter);
    }, 300);
  };

  // 🧩 Apply both search + filter
  const applyFilters = (search, filter) => {
    let filtered = [...originalTransactions];

    // Filter by search
    if (search && search.length > 2) {
      filtered = filtered.filter((item) =>
        item.amount?.toLowerCase().includes(search.toLowerCase())
      );
    }

    // Filter by type
    if (filter !== "all") {
      filtered = filtered.filter(
        (tx) => tx.type?.toLowerCase() === filter.toLowerCase()
      );
    }

    setTransactions(filtered);
  };

  // 🔁 Re-run filter whenever filter type changes
  useEffect(() => {
    applyFilters(searchQuery, selectedFilter);
  }, [selectedFilter]);

  return (
    <div style={{ height: windowSize[1] - 140 }}>
      <Header
        onSearch={handleSearch}
        onFilterChange={(type) => setSelectedFilter(type)}
      />
      <Menu />

      {loading ? (
        <Loading height={windowSize[1] - 180} />
      ) : transactions.length === 0 ? (
        <NotFound
          title="Nothing here"
          subtext="No Transactions Found."
          height={windowSize[1] - 180}
        />
      ) : (
        <div
          className="hide-scrollbar"
          style={{
            height: windowSize[1] - 180,
            overflow: "auto",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
          }}
        >
          {transactions.map((item, index) => (
            <TransactionCard key={index} item={item} />
          ))}
        </div>
      )}
    </div>
  );
}
